import React from 'react'
import Navbar from "../../Components/Navbar/Navbar";
import './Legal.scss'

function Email() {
    return (
        <div id='legal'>
            <Navbar homeNav="navbar navbar-expand-md bgLegal" />
            <div className='legalSpace'>
                <h1 className='legalHeader'>Contact Information</h1>
                <p>Need to get in touch with us? Contact us via email: chrrisrios@gmail.com</p>
            </div>
        </div>
    )
}

export default Email